import { createEndpoint } from '@/shared/models/api';
import { Informative } from '@/app/api/morgan-thermal';
import { CompanyInformation } from '@/app/api/morgan-thermal/company';

export const enableCompany = createEndpoint<Informative>(({ fetch }) => {
  return (companyId: CompanyInformation['id']) => fetch(`/Company/Enable/${companyId}`, { method: 'POST' });
});